import React from 'react';
import { useLocation } from 'react-router-dom';

import { getItemFromStorage } from 'commons/localStorage';
import { getAffirmReturnParams } from 'components/consumer/user-protection-plans';
import OrderSummary from 'components/consumer/user-orders-info/OrderDetailsModal/OrderSummary';
import useUserData from 'data-hooks/useUserData';
import OrderSuccessNew from '../OrderSuccessNew/OrderSuccessNew';

const OrderThankYou = () => {
  const { search } = useLocation();
  const { order_id } = getAffirmReturnParams(search);
  const orderInfo = getItemFromStorage('orderThankYou');

  const { isLoggedIn } = useUserData();

  if (!((order_id && isLoggedIn) || orderInfo)) return null;

  if (order_id && isLoggedIn) {
    return <OrderSummary order_id={order_id} />;
  }

  const {
    orderId,
    orderSummary,
    shipping,
    payment,
    shippingGroups,
    deliveryInfo,
    cartData,
  } = orderInfo;

  return (
    <OrderSuccessNew
      orderId={orderId}
      orderSummary={orderSummary}
      shipping={shipping}
      payment={payment}
      shippingGroups={shippingGroups}
      deliveryInfo={deliveryInfo}
      cartData={cartData}
    />
  );
};

export default OrderThankYou;
